/* Cafe Supply — favourites.
 *
 * Saved in localStorage, on the buyer's device. Customer metafields would be
 * the better home, because then a favourite would follow the account to the
 * phone in the stockroom and the laptop in the office, but writing those needs
 * the Admin API and the Shopify connector is not reachable. When it is, move
 * the store and keep this file as the read path.
 *
 * What is kept per entry is only what the cards need to render — handle,
 * title, variant id, image, vendor. No price: prices are gated, and a stale
 * price cached in a browser is a bug waiting to happen.
 */
(function () {
  var KEY = 'cs_favourites_v1';

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      /* private window, blocked storage, corrupt value — behave as empty */
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, 200)));
      return true;
    } catch (e) {
      return false;
    }
  }

  function keyOf(item) {
    return String(item.handle || item.variantId || '');
  }

  function has(id) {
    id = String(id);
    return read().some(function (f) { return keyOf(f) === id; });
  }

  function add(item) {
    var list = read();
    if (list.some(function (f) { return keyOf(f) === keyOf(item); })) return list;
    list.unshift({
      handle: item.handle || '',
      title: item.title || '',
      variantId: item.variantId || null,
      image: item.image || '',
      vendor: item.vendor || '',
      added: Date.now()
    });
    write(list);
    return list;
  }

  function remove(id) {
    id = String(id);
    var list = read().filter(function (f) { return keyOf(f) !== id; });
    write(list);
    return list;
  }

  function toggle(item) {
    return has(keyOf(item)) ? (remove(keyOf(item)), false) : (add(item), true);
  }

  function emit() {
    document.dispatchEvent(new CustomEvent('cs:favourites', {
      detail: { count: read().length },
      bubbles: true
    }));
  }

  var HEART_ON = '<svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true"><path fill="currentColor" d="M12 21s-7.5-4.6-9.6-9A5.3 5.3 0 0 1 12 6.1 5.3 5.3 0 0 1 21.6 12c-2.1 4.4-9.6 9-9.6 9Z"/></svg>';
  var HEART_OFF = '<svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="1.8" d="M12 20.3C9.9 19 4 15 2.9 11.4A4.6 4.6 0 0 1 12 7.3a4.6 4.6 0 0 1 9.1 4.1C20 15 14.1 19 12 20.3Z"/></svg>';

  function paint(btn) {
    var on = has(btn.getAttribute('data-cs-fav'));
    btn.innerHTML = on ? HEART_ON : HEART_OFF;
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Remove from favourites' : 'Save to favourites');
    btn.title = on ? 'Saved' : 'Save to favourites';
  }

  function bind(root) {
    (root || document).querySelectorAll('[data-cs-fav]').forEach(function (btn) {
      if (btn.__csFavBound) return;
      btn.__csFavBound = true;
      paint(btn);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggle({
          handle: btn.getAttribute('data-cs-fav'),
          title: btn.getAttribute('data-cs-fav-title') || '',
          variantId: btn.getAttribute('data-cs-fav-variant') || null,
          image: btn.getAttribute('data-cs-fav-image') || '',
          vendor: btn.getAttribute('data-cs-fav-vendor') || ''
        });
        document.querySelectorAll('[data-cs-fav="' + CSS.escape(btn.getAttribute('data-cs-fav')) + '"]')
          .forEach(paint);
        emit();
      });
    });
  }

  window.csFavourites = {
    list: read, has: has, add: add, remove: remove, toggle: toggle,
    bind: bind, repaint: function () { document.querySelectorAll('[data-cs-fav]').forEach(paint); }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(); });
  } else {
    bind();
  }
  /* sections re-render on cart updates and theme-editor edits */
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
